module.exports = __webpack_public_path__ + "img/terracenew_box06.3abc5871.jpg";